import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ACTUAL_FLOW_STEPS, STYLES, SUBMIT_TYPES, TEXTS } from '../consts/consts';
import LinedStepper from '../../../../generic-components/LinedStepper';
import MainContent from '../../../../generic-components/Layout/MainContent';
import { OnboardingContext } from '../InvoiceOnboarding';
import Button from '../../../../generic-components/Button';
import Heading from '../../../../generic-components/Heading';
import { PaymentsList } from './PaymentsList';
import Icon from '../../../../generic-components/Icon';
import { backBlackIcon } from '../../../../assets/svg';
import { InvoicesContext } from '../../contexts/InvoicesContext';

export const StepPayments = () => {
  const { t } = useTranslation();
  const invoiceContext = useContext(InvoicesContext);
  const flowContext = useContext(OnboardingContext);
  const { activeStep, onStepSubmit, isLoadingState } = flowContext;
  const [isScrollMode, setIsScrollMode] = useState<boolean>(false);
  const isEditMode = !!invoiceContext.initialObStep;
  return (
    <MainContent className={STYLES.PAGES.PAYMENTS.MAIN_CONTENT}>
      <div
        className={`flex flex-col items-center w-full pb-[14px] py-[26px] ${isScrollMode ? 'shadow-bottomShadow' : ''}`}
      >
        {!isEditMode && (
          <LinedStepper
            currentStep={activeStep}
            mainContainerCSS={STYLES.LINED_STEPPER.MAIN_CONTAINER}
            passStepAnimation={STYLES.LINED_STEPPER.STEP_ANIMATION}
            stepCSS={STYLES.LINED_STEPPER.STEP}
            stepContainerCSS={STYLES.LINED_STEPPER.STEP_CONTAINER}
            stepsAmount={ACTUAL_FLOW_STEPS}
          />
        )}
        <Heading className={STYLES.PAGES.PAYMENTS.TITLE} title={t(TEXTS.STEP_PAYMENTS.TITLE)} />
        <Heading className={STYLES.PAGES.PAYMENTS.SUB_TITLE} title={t(TEXTS.STEP_PAYMENTS.SUB_TITLE)} />
      </div>
      <PaymentsList isScrollable={(mode) => setIsScrollMode(mode)} />
      <div className={STYLES.PAGES.PAYMENTS.NAV_BUTTONS_CONTAINER_WRAPPER}>
        <div
          className={`${STYLES.PAGES.PAYMENTS.NAV_BUTTONS_CONTAINER} ${isEditMode ? 'justify-center' : 'justify-between'}`}
        >
          {!isEditMode && (
            <Button
              onClick={() => onStepSubmit({ type: SUBMIT_TYPES.PAYMENTS.NAVIGATE_BACK, data: '' })}
              childElement={<Icon className={STYLES.PAGES.COLOR.CTA_BACK_ICON} src={backBlackIcon} />}
              title={t(TEXTS.STEP_COLOR.CTA_BACK)}
              className={STYLES.PAGES.COLOR.CTA_BACK}
              id='elCtaBack'
              disable={isLoadingState}
            />
          )}
          <Button
            disable={isLoadingState}
            isLoading={isLoadingState}
            onClick={() => onStepSubmit({ type: SUBMIT_TYPES.PAYMENTS.FINISH_CUSTOMIZATION, data: '' })}
            title={invoiceContext.initialObStep ? t('ACTION_TYPE_UPDATE') : t(TEXTS.STEP_COLOR.CTA_NEXT)}
            className={STYLES.PAGES.COLOR.CTA_CONTINUE}
            id='elCtaContinue'
          />
        </div>
      </div>
    </MainContent>
  );
};
